import React from "react";
import { AppleFilled } from "@ant-design/icons";
import "../styles/button.css";

export const AppleStore = () => {
  return (
    <>
      <div className="app-button">
        <a
          href="https://apps.apple.com/us/app/dory-delivery/id6477858961"
          className="button-content flex items-center space-x-3"
        >
          <AppleFilled style={{ fontSize: "30px" }} className="mr-1" />
          <div className="flex flex-col leading-tight">
            <span className="text-xs">GET IT ON</span>
            <span className="text-base font-semibold">Apple App Store</span>
          </div>
        </a>
      </div>
    </>
  );
};
